import React, { FC } from 'react';
import List from '@mui/material/List';
import { ReferenceSidebarItem } from './ReferenceSidebarItem';
import { useStyles } from './useStyles';
import Stack from '@mui/material/Stack';
import { FeedbackTypes } from '@web-kc/core/api';

interface Props {
  faqData: FeedbackTypes['TopicDto'][];
  activeTopic?: string;
  setActiveTopic: (topic?: string) => void;
}

export const ReferenceSidebar: FC<Props> = ({
  faqData,
  activeTopic,
  setActiveTopic,
}) => {
  const { classes } = useStyles();

  return (
    <List component="nav" className={classes.appMenu} disablePadding>
      <Stack direction="column">
        {faqData.map((topic) => (
          <Stack key={topic.id}>
            <ReferenceSidebarItem
              topic={topic}
              activeTopic={activeTopic}
              setActiveTopic={setActiveTopic}
            />
          </Stack>
        ))}
      </Stack>
    </List>
  );
};

export default ReferenceSidebar;
